import React, { Component } from 'react';
import calendar from './Calendar.svg'
import redessociais from './redessociais.svg'
import mapa from './mapa.svg'
import googleplay from './googleplay.png'
import appstore from './appstore.png'
import './index.css'

class Conteudo extends Component {
    render() {
        return (
            <div>
                <div className="bg-light bdone">
                    <div className="container">
                        <div className="row">
                            <div className="col-6">
                                <h1 className="font-weight-bold display-1 text-primary">Agendar.me</h1>
                                <h5 className="font-weight-bold text-dark display-4">A solução de forma rápida para gerenciar seu estabelecimento.</h5>
                            </div>
                            <div className="col-6">
                                <img src={calendar} className="img-fluid imgcalendar" alt="Imagem responsiva" />
                            </div>
                        </div>
                        {/* <div className="row">
                            <h6 className="font-weight-bold text-dark display-5 text-center embreve">Em breve</h6>
                        </div> */}
                        <div className="row store">
                            <div className="col-2">
                                <img src={googleplay} className="img-fluid" alt="Imagem responsiva" />
                            </div>
                            <div className="col-2">
                                <img src={appstore} className="img-fluid" alt="Imagem responsiva" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-dark bdtwo">
                    <div className="container">
                        <div className="row">
                            <div className="col-6">
                                <h1 className="display-2 text-white">Redes Sociais</h1>
                                <p className="font-weight-bold text-white display-3">
                                    Você pode nos encontrar no instagram...
                                @.</p>
                            </div>
                            <div className="col-6">
                                <img src={redessociais} className="img-fluid" alt="Imagem responsiva" />
                            </div>
                        </div>
                        <div className="col-12">
                            <h1 className="display-6 text-center text-white">#WeAreAgendarme</h1>
                        </div>
                    </div>
                </div>

                <div className="bg-info bdthree">
                    <div className="container">
                        <div className="col-12">
                            <h1 className="display-3 text-center text-white">Onde Estamos:</h1>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <img src={mapa} className="img-fluid" alt="Imagem responsiva" />
                            </div>
                            <div className="col-6">
                                <p className="font-weight-bold text-white display-3"> Estamos localizados na cidade de Jundiaí - SP .</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Conteudo;